module.exports = __webpack_public_path__ + "static/media/i-loc.3bf2ad12.svg";